import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Prestations from './pages/Prestations';
import AmmaAssis from './pages/AmmaAssis';
import Entreprises from './pages/Entreprises';
import About from './pages/About';
import Reviews from './pages/Reviews';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/prestations" element={<Prestations />} />
            <Route path="/amma-assis" element={<AmmaAssis />} />
            <Route path="/entreprises" element={<Entreprises />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/avis" element={<Reviews />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
